import React from "react";
import AppPersonBadge from "../../../../components/AppPersonBadge";
import DocsNiceToKnow from "../../shared/DocsNiceToKnow";
import DocsPreviewPanel from "../../shared/DocsPreviewPanel";
import DocsSectionCard from "../../shared/DocsSectionCard";

const sizes = ["xs", "sm", "md", "lg", "xl"];

const tones = [
  { tone: "neutral", label: "Neutral", name: "Mara Meier" },
  { tone: "solid", label: "Solid", name: "Tim Roth" },
  { tone: "brand", label: "Brand", name: "Lea Suter" },
  { tone: "custom", label: "Custom", name: "Nico Baur", color: "#8b5cf6" },
];

const progressStates = [
  { label: "Neutral", progress: 0, progressTone: "neutral", name: "Ana Frei" },
  { label: "Partial", progress: 0.55, name: "Ben Graf" },
  { label: "Complete", progress: 1, name: "Cara Lutz" },
  { label: "Over", progress: 1, overage: 0.24, progressTone: "over", name: "Dario Ott" },
];

const notes = [
  "Ein Kreis mit den Initialen einer Person – überall gleich, egal ob Dashboard, Verfügbarkeit, Schichtplan oder Team.",
  "Initialen kommen aus name (Vorname + Nachname) oder werden über initials überschrieben.",
  "onClick macht den Badge zum Button inklusive Fokusring; ohne onClick ist er rein dekorativ (aria-hidden).",
];

const highlights = [
  "showProgress zeichnet den Auslastungsring: grün bis zum Soll, rot mit Überhang.",
  "tone=\"custom\" färbt den Badge in einer Abteilungsfarbe (Prop color).",
];

function Row({ label, children }) {
  return (
    <div className="ds-docs-person-badge-row">
      <div className="ds-docs-person-badge-row__label">{label}</div>
      <div className="ds-docs-person-badge-row__content">{children}</div>
    </div>
  );
}

export default function PersonBadgesDocs() {
  return (
    <DocsSectionCard title="Person Badges">
      <div className="ds-docs-person-badges">
        <div className="ds-docs-person-badge-section">
          <DocsPreviewPanel title="AppPersonBadge – Sizes">
            <div className="ds-docs-preview-surface">
              <Row label="Sizes">
                {sizes.map((size) => (
                  <div key={size} className="ds-docs-person-badge-item">
                    <AppPersonBadge name="Mara Meier" size={size} />
                    <span className="ds-docs-person-badge-item__caption">{size.toUpperCase()}</span>
                  </div>
                ))}
              </Row>

              <Row label="Tones">
                {tones.map((entry) => (
                  <div key={entry.tone} className="ds-docs-person-badge-item">
                    <AppPersonBadge name={entry.name} tone={entry.tone} color={entry.color} />
                    <span className="ds-docs-person-badge-item__caption">{entry.label}</span>
                  </div>
                ))}
              </Row>

              <Row label="Klickbar">
                <div className="ds-docs-person-badge-item">
                  <AppPersonBadge name="Mara Meier" onClick={() => {}} ariaLabel="Statistik öffnen" />
                  <span className="ds-docs-person-badge-item__caption">onClick</span>
                </div>
              </Row>

              <Row label="Fortschritt">
                {progressStates.map((entry) => (
                  <div key={entry.label} className="ds-docs-person-badge-item">
                    <AppPersonBadge
                      name={entry.name}
                      showProgress
                      progress={entry.progress}
                      overage={entry.overage}
                      progressTone={entry.progressTone}
                    />
                    <span className="ds-docs-person-badge-item__caption">{entry.label}</span>
                  </div>
                ))}
              </Row>

              <Row label="Fortschritt + klickbar">
                {sizes.slice(1).map((size) => (
                  <div key={size} className="ds-docs-person-badge-item">
                    <AppPersonBadge
                      name="Cara Lutz"
                      size={size}
                      showProgress
                      progress={0.72}
                      onClick={() => {}}
                      ariaLabel="Statistik öffnen"
                    />
                    <span className="ds-docs-person-badge-item__caption">{size.toUpperCase()}</span>
                  </div>
                ))}
              </Row>
            </div>
          </DocsPreviewPanel>
          <DocsNiceToKnow items={notes} highlightItems={highlights} />
        </div>
      </div>
    </DocsSectionCard>
  );
}
